export default __webpack_public_path__ + "static/media/calendar.276c7467.svg";